import { createApp } from 'vue'
import App from './App.vue'
import VueCookies from 'vue-cookies'
import packageJson from '../package.json'

//createApp(App).use(VueCookies).mount('#app')


const app = createApp(App)

app.provide('wdm', { 
    'version' : packageJson.version,
    'versiondate': packageJson.versiondate,
    'versiontime': packageJson.versiontime,
    }) 
app.use(VueCookies)
app.mount('#app')

